module.exports = __webpack_public_path__ + "static/media/felipe.703201fb.png";